/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Resource quota status. 
*/
export enum QuotaStatus {
  QuotaStatusUnspecified = 'QUOTA_STATUS_UNSPECIFIED',
  InQuota = 'IN_QUOTA',
  SizeExceeded = 'SIZE_EXCEEDED',
  ObjectCountExceeded = 'OBJECT_COUNT_EXCEEDED',
  MaxResourcesExceeded = 'MAX_RESOURCES_EXCEEDED',
  ExcludedFromQuota = 'EXCLUDED_FROM_QUOTA',
  InQuotaOverridden = 'IN_QUOTA_OVERRIDDEN'
}
